import React from "react";
import { getMemberInitials, getMemberName } from "../helpers";

const TeamMemberCell = ({ member }) => {
  const imageUrl = member?.Profiles?.PictureUrl;

  return (
    <div className="team-page__member">
      {imageUrl ? (
        <img className="team-page__avatar" src={imageUrl} alt={getMemberName(member)} />
      ) : (
        <div className="team-page__avatar team-page__avatar--fallback">
          {getMemberInitials(member)}
        </div>
      )}
      <div className="team-page__member-copy">
        <div className="team-page__member-name">{getMemberName(member)}</div>
        <div className="team-page__member-email">{member?.EmailAddress || "N/A"}</div>
      </div>
    </div>
  );
};

export default TeamMemberCell;
